import React, { useState } from "react";
import { guardianAlertService } from "../../../../services/guardianAlertService";
import {
  getAlertRequestSearchErrorMessage,
  isValidAlertCode,
  normalizeAlertCode,
} from "../../../../utils/guardianAlertByCode";
import {
  SearchBar,
  SearchField,
  SearchInput,
  SearchButton,
  SearchHint,
  SearchError,
} from "../../ViewAlerts/AlertCodeSearchBar/styles";

/**
 * Mesmo layout de AlertCodeSearchBar (view_alerts),
 * buscando solicitação via GET /guardian/alert_request/by-code/{code}/.
 */
export default function AlertRequestCodeSearchBar({
  initialCode = "",
  autoSearch = false,
  onFound,
}) {
  const [code, setCode] = useState(initialCode);
  const [searching, setSearching] = useState(false);
  const [error, setError] = useState(null);
  const [autoRan, setAutoRan] = useState(false);

  const handleSearch = async (rawCode = code) => {
    const normalized = normalizeAlertCode(rawCode);

    if (!isValidAlertCode(normalized)) {
      setError("Informe um código de 5 caracteres alfanuméricos.");
      return;
    }

    setSearching(true);
    setError(null);

    try {
      const data = await guardianAlertService.getAlertRequestByCode(normalized);

      if (!data?.success || !data?.alert_request) {
        setError("Código não encontrado. Confira o e-mail ou a lista.");
        return;
      }

      onFound?.(data.alert_request);
    } catch (err) {
      setError(getAlertRequestSearchErrorMessage(err));
    } finally {
      setSearching(false);
    }
  };

  React.useEffect(() => {
    if (!autoSearch || autoRan) return;
    const normalized = normalizeAlertCode(initialCode);
    if (!isValidAlertCode(normalized)) return;

    setAutoRan(true);
    handleSearch(normalized);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [autoSearch, autoRan, initialCode]);

  return (
    <SearchBar>
      <SearchField>
        <label htmlFor="alert-request-code-search">Código da solicitação</label>
        <SearchInput
          id="alert-request-code-search"
          type="text"
          value={code}
          maxLength={5}
          placeholder="Ex.: 4414B (código do e-mail)"
          autoComplete="off"
          spellCheck={false}
          disabled={searching}
          onChange={(event) => {
            setCode(event.target.value.toUpperCase().replace(/[^0-9A-Z]/gi, ""));
            setError(null);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              handleSearch();
            }
          }}
        />
        <SearchHint>5 caracteres do e-mail FIRMS / coluna Código</SearchHint>
      </SearchField>

      <SearchButton type="button" onClick={() => handleSearch()} disabled={searching}>
        {searching ? "Buscando..." : "Buscar"}
      </SearchButton>

      {error ? <SearchError role="alert">{error}</SearchError> : null}
    </SearchBar>
  );
}
